export default "__VITE_ASSET__fBc9SDQB__"